import { render } from "./MenuPill.vue?vue&type=template&id=885997cc&scoped=true"
import script from "./MenuPill.vue?vue&type=script&lang=js"
export * from "./MenuPill.vue?vue&type=script&lang=js"

import "./MenuPill.vue?vue&type=style&index=0&id=885997cc&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885997cc"]])

export default __exports__